import { render, staticRenderFns } from "./Respond.vue?vue&type=template&id=41a827ab&scoped=true"
import script from "./Respond.vue?vue&type=script&lang=js"
export * from "./Respond.vue?vue&type=script&lang=js"
import style0 from "./Respond.vue?vue&type=style&index=0&id=41a827ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a827ab",
  null
  
)

export default component.exports